import { createEntityReducer } from "@selas/state-management";
import Endpoint from "../../services/api/endpoint";
import { ISessionNote } from "../../utils/types/models";

export default createEntityReducer<ISessionNote>(Endpoint.SessionNotes, Endpoint.SessionNotesList);
